import React from "react";

export function StepBadge({ n, title, subtitle }) {
  return (
    <div className="flex items-start gap-3 mb-4">
      <span className="shrink-0 w-7 h-7 rounded-full bg-[#631024] text-white text-sm font-bold flex items-center justify-center">
        {n}
      </span>
      <div>
        <h2 className="font-display font-bold text-[#2a1a1e] leading-tight">{title}</h2>
        <p className="text-sm text-[#9b8388]">{subtitle}</p>
      </div>
    </div>
  );
}

export function Section({ children }) {
  return (
    <section className="rounded-2xl border border-[#efe4e6] bg-white p-5 sm:p-6">
      {children}
    </section>
  );
}
